export function getByValue(map: any[], searchValue: any): any {
  for (const [key, value] of map.entries()) {
    if (value === searchValue) {
      return key;
    }
  }
}

// check if map enough (without .entries())
// don't need the map.entries(), the map itself acts as an iterator

export function getKey(map: any, val: any): any {
  return [...map].find(([_key, value]) => val === value)?.[0];
}
